module.exports = __webpack_public_path__ + "media/images/menu/carina-f331b7ac4a102afbd86203150adf01e5.jpg";